
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const PostLaunchCTASection = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-r from-nation-purple to-nation-blue text-white">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          NationCard™ Cayman Islands is Now Live!
        </h2>
        
        <p className="text-xl opacity-90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Join hundreds of engaged Cayman citizens already using the platform to make their voices heard and shape the future of governance.
        </p>
        
        <Button size="lg" className="bg-white hover:bg-gray-100 text-nation-purple hover:text-nation-purple-dark shadow-lg hover:shadow-xl transition-all" asChild>
          <Link to="/cards/KY" className="flex items-center gap-2 px-8 py-6 text-lg">
            Access the Platform Now <ArrowRight className="h-5 w-5" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default PostLaunchCTASection;
